import {
  Panel,
  PanelType,
  PrimaryButton,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';
import { ErrorLabel } from '../../../../../components/ErrorLabel';
import { decodeHtmlentities } from '../../../../../utilities/html';
import { UploadFile } from '../../appendixUpload/UploadFile';
import { useUploadInviteeFile } from './uploadFileInviteePanel/utility/useUploadInviteeFile';
import { getConfiguration } from './uploadFileInviteePanel/utility/getConfiguration';
import { useTexts } from './uploadFileInviteePanel/utility/useTexts';

const UploadFileInviteePanel = ({ hearingId, selectedInvitationSource }) => {
  const {
    file,
    fileExtension,
    maxFileSizeInBytes,
    exampleFileToDownload,
  } = getConfiguration(selectedInvitationSource);

  const {
    headerText,
    closeButtonAriaLabel,
    chooseFile,
    description,
    callout,
    exampleFile,
    note,
    uploadError,
    cancel,
    confirm,
  } = useTexts(selectedInvitationSource, fileExtension);

  const {
    fileName,
    fileToUpload,
    fileUrl,
    hasError,
    isPanelOpen,
    isUploadingFile,
    onChangeFile,
    onPanelClose,
    onConfirm,
  } = useUploadInviteeFile(
    hearingId,
    selectedInvitationSource,
    fileExtension,
    maxFileSizeInBytes,
  );

  return (
    <div>
      <Panel
        isOpen={isPanelOpen}
        onDismiss={onPanelClose}
        isLightDismiss
        onOuterClick={() => {}}
        type={PanelType.medium}
        headerText={headerText}
        closeButtonAriaLabel={closeButtonAriaLabel}
      >
        <div>
          <div className="panel-content">
            <p style={{ fontWeight: 500, fontSize: 16 }}>{chooseFile}</p>
            <p>{description}</p>
            <p>
              <b>{callout}</b>
            </p>
            <a href={file} download={exampleFileToDownload}>
              {exampleFile}
            </a>
            <p>{note}</p>
            <UploadFile
              onUploadFiles={onChangeFile}
              maxFileSize={maxFileSizeInBytes}
              allowedFileTypes={`.${fileExtension}`}
            />
            {fileName && fileUrl && (
              <a href={fileUrl} download={fileName}>
                <span className="light">{decodeHtmlentities(fileName)}</span>
              </a>
            )}
            {hasError && <ErrorLabel>{uploadError}</ErrorLabel>}
          </div>
          <div className="panel-buttons">
            {isUploadingFile && <Spinner size={SpinnerSize.large} />}
            <PrimaryButton
              text={cancel}
              onClick={onPanelClose}
              disabled={isUploadingFile}
            />
            <PrimaryButton
              text={confirm}
              disabled={isUploadingFile || !fileToUpload}
              onClick={() => fileToUpload && onConfirm(fileToUpload)}
            />
          </div>
        </div>
      </Panel>
    </div>
  );
};

export { UploadFileInviteePanel };
